<template>
  <div 
    class="card" 
    @mouseenter="hoverId = item.codigo"
    @mouseleave="hoverId = null"
    :style="{width: '200px'}"
  >
    <div
      ref="current-speaker"
      class="speaker-img"
      :style="{
        '--zoom-size': `${settings.layout.zoom || '125'}%`,
        backgroundImage: `url('${item.url_avatar}')`,
        height: settings.layout.linkedinIcon || hoverId === item.codigo  ? '120px': '150px',  
      }"    
    >
    </div>

    <div 
      class="overlapping px-5 py-1" 
      :style="{
        height: settings.layout.linkedinIcon || hoverId === item.codigo  ? '120px': '90px',  
        backgroundColor: settings.layout.color1 || '#0A9AED'      
      }"
    >
      <span 
        class="titleCard" 
        :style="{
          color: settings.layout['text-color1'] || '#FFFFFF', 
          fontSize: item.nome.length > 15 ? '14px': '17px'
        }"
      >
      {{item.nome}}
      </span>

      <v-tooltip bottom max-width="220" :disabled="!infoTooltip" :color="settings.layout['tooltip-color']">
        <template v-slot:activator="{ on }">
          <span 
            v-on="on"
            ref="info-speaker"
            class="subtitleCard" 
            :style="{
              color: settings.layout['text-color2'] || '#FFFFFF'
            }"
          >
            {{ getSpeakerInfo }}
          </span>
        </template>
        <div :style="{'font-size': '0.8rem'}">
          <span class="d-block pb-2">
            <b :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF', 'font-weight': '900'}">
              {{ item.cargo }}
            </b>
          </span>

          <span class="d-block" :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF'}">
            {{ item.empresa }}
          </span>
        </div>
      </v-tooltip>

      <div 
        v-if="item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo)"
        :class="['linkedin text-center pt-2']"
      >
        <v-btn 
          fab 
          color="transparent" 
          class="elevation-0" 
          x-small 
          @click.stop="$emit('onClickLinkedin', item)"
        >
            <i 
              class="fa-brands fa-linkedin" 
              :style="{
                'font-size': '1.4rem',
                'color': settings.layout['color2'] || '#FFF',
              }"
            >
            </i>
        </v-btn>
      </div>
    </div> 

  </div>
</template>

<script>

export default {
  props: ["item", "settings"],
  computed: {
    getBoxShadow () {
      const shadow = this.settings.layout.shadow
      const distance = this.settings.layout.distance
      if (shadow) return `${distance}px ${distance}px 0 1px ${shadow}`
      else return 'none'
    },

    getSpeakerInfo () {
      if (this.settings.layout.companyPosition) return `${this.item.cargo} - ${this.item.empresa}`
      else return this.item.empresa
    }    
  },

  data: () => ({
    hoverId: null,
    infoTooltip: false
  }),

  watch: {
    hoverId (id) {
      const currentSpeaker = this.$refs['current-speaker']
      if (id === this.item.codigo) {
        currentSpeaker.style.backgroundSize = `var(--zoom-size) !important`
        const infoSpeaker = this.$refs['info-speaker']
        const isInfoSpeakerEllipsed = infoSpeaker.scrollHeight > infoSpeaker.clientHeight
        this.infoTooltip = isInfoSpeakerEllipsed
      } else {
        currentSpeaker.style.backgroundSize = `100%`
        this.infoTooltip = false
      }
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 240px;
  max-width: 200px;
  transition: all 1s;
}

.card:hover {
  cursor: pointer;
  transform: translateY(-8px);
}

.speaker-img {
  display: flex;
  position: relative;
  transition: all 0.5s;
  width: 200px;
  background-position: center;
  background-size: 100%;
}

.speaker-img:hover {
  cursor: pointer;
  background-size: var(--zoom-size) !important;
}

span {
  display: block;
}

.overlapping {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  width: 100%;
  transition: all 0.5s ease;
}

.titleCard {
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 30px;
  text-align: center;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  max-height: 100%; 
  text-transform: uppercase; 
}

.subtitleCard {
  font-size: 12.5px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
  line-height: 18px;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 100%;
  color: #666D80;
  text-transform: uppercase;
}

.linkedin {
  display: flex;
  flex-direction: column;
}
</style>
